import React, { useMemo, useState } from "react";
import { FileCheck, FileText, Laptop, MessageSquare } from "lucide-react";

import { SidebarMenu } from "components/ui/SidebarMenu";

// filter is the value the page switches on (activeSubMenu): SMS / EMAIL /
// LETTERS / SICK CERTS.
const MENU_ITEMS = [
  { label: "Sms", filter: "SMS", Icon: MessageSquare },
  { label: "Email", filter: "EMAIL", Icon: Laptop },
  { label: "Letters", filter: "LETTERS", Icon: FileText },
  { label: "Sick Certs", filter: "SICK CERTS", Icon: FileCheck },
];

const CommunicationMenu = ({ menuClick }) => {
  const [activeLabel, setActiveLabel] = useState(MENU_ITEMS[0].label);

  const items = useMemo(
    () =>
      MENU_ITEMS.map((item) => ({
        label: item.label,
        Icon: item.Icon,
        onClick: () => {
          setActiveLabel(item.label);
          menuClick(item.filter);
        },
      })),
    [menuClick]
  );

  return <SidebarMenu items={items} activeItem={activeLabel} iconSize={18} />;
};

export { CommunicationMenu };
